/* Svensk katalog for locale-commerce-preferences-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'pref.salesMode': 'Standardvy för ny försäljning',
  'pref.salesModeSub': 'Används för faktura, offert, orderbekräftelse, kreditfaktura och annan försäljning. Du kan byta vy tillfälligt i formuläret.',
  'pref.purchaseMode': 'Standardvy för nya inköp',
  'pref.purchaseModeSub': 'Välj om nya inköp normalt ska öppnas steg för steg eller med hela formuläret på en sida.',
  'pref.mode.firstChoiceHelp': 'Valet blir din standard. Du kan byta vy i formuläret eller ändra standarden senare under Inställningar → Preferenser.',
  'pref.mode.saveFailed': 'Vyn byttes, men standardvalet kunde inte sparas. Försök igen under Inställningar → Preferenser.',
  'pref.mode.unsupported': 'Ogiltigt vyval.',
});
